var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        attrs: {
          type: "horizon",
          tabItems: _vm.tabItems,
          inlineLabel: true,
          dense: true,
          height: _vm.tabHeight,
        },
        on: {
          "update:tabItems": function ($event) {
            _vm.tabItems = $event
          },
          "update:tab-items": function ($event) {
            _vm.tabItems = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    popupParam: _vm.popupParam,
                    facilityStatusTable: _vm.facilityStatusTable,
                    hcfFacilityTypeItems: _vm.hcfFacilityTypeItems,
                    contentHeight: _vm.contentHeight,
                  },
                  on: {
                    "update:facilityStatusTable": function ($event) {
                      _vm.facilityStatusTable = $event
                    },
                    "update:facility-status-table": function ($event) {
                      _vm.facilityStatusTable = $event
                    },
                    "update:hcfFacilityTypeItems": function ($event) {
                      _vm.hcfFacilityTypeItems = $event
                    },
                    "update:hcf-facility-type-items": function ($event) {
                      _vm.hcfFacilityTypeItems = $event
                    },
                    getDetail: _vm.getDetail,
                    plantChange: _vm.plantChange,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }